module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('setting-title', {
    attrs: {
      "title": "人群细分设置"
    }
  }), _c('div', {
    staticClass: "zone content-part"
  }, [_c('domain-select', {
    attrs: {
      "extra": "为网站$domain绑定人群细分"
    },
    on: {
      "change": _vm.onDomainChange
    }
  })], 1), _c('div', {
    staticClass: "toolbar-row"
  }, [_c('div', {
    staticClass: "btn btn-primary btn-big",
    on: {
      "click": _vm.openAddCrowdModal
    }
  }, [_vm._v("新建人群")])]), _c('div', {
    staticClass: "zone"
  }, [_c('table', {
    staticClass: "data-table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(item) {
    return _c('th', {
      style: ({
        minWidth: item.width + 'px'
      })
    }, [_vm._v(_vm._s(item.title))])
  }))]), (_vm.isLoading) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "loading",
    attrs: {
      "colspan": 4
    }
  }, [_c('img', {
    attrs: {
      "src": "//p.ssl.qhimg.com/t010aba4345b02168d6.gif"
    }
  })])])]) : (!_vm.isLoading && _vm.tableDataList.length == 0) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "noresult",
    attrs: {
      "colspan": 4
    }
  }, [_vm._v("暂无相关数据")])])]) : _c('tbody', _vm._l((_vm.tableDataList), function(item, index) {
    return _c('tr', _vm._l((_vm.columns), function(columnItem) {
      return _c('td', [_c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (columnItem.key == 'name' && item.sys_flag == 1),
          expression: "columnItem.key == 'name' && item.sys_flag == 1"
        }],
        staticClass: "system"
      }, [_vm._v("系统")]), (columnItem.render) ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(columnItem.render(index, item[columnItem.key], item))
        }
      }) : (columnItem.key != 'opt') ? _c('span', [_vm._v(_vm._s(item[columnItem.key]))]) : _c('span', [(item.sys_flag === 1) ? _c('a', {
        staticClass: "mgr",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.openShowCrowdModal(item)
          }
        }
      }, [_vm._v("查看")]) : _c('a', {
        staticClass: "mgr",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.openEditCrowdModal(item)
          }
        }
      }, [_vm._v("编辑")]), _c('a', {
        staticClass: "mgr",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.openCopyCrowdModal(item)
          }
        }
      }, [_vm._v("复制")]), (_vm.isDjPlatform !== 0) ? _c('a', {
        staticClass: "mgr",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.gotoDetail(item)
          }
        }
      }, [_vm._v("访客细查")]) : _vm._e(), (item.sys_flag != 1) ? _c('a', {
        staticClass: "mgr",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.removeCrowd(item)
          }
        }
      }, [_vm._v("删除")]) : _vm._e()])])
    }))
  }))]), (_vm.total > _vm.ps) ? _c('v-pagination', {
    attrs: {
      "total": _vm.total,
      "pn": _vm.pn,
      "ps": _vm.ps
    },
    on: {
      "updatepage": _vm.updatePage
    }
  }) : _vm._e()], 1), _c('v-modal', {
    attrs: {
      "visible": _vm.syncSetting,
      "title": "同步DMP设置"
    },
    on: {
      "closemodal": function($event) {
        _vm.closeSyncSetting()
      }
    }
  }, [_c('div', {
    staticClass: "modal-bd form sync-container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("点睛账户：")]), _c('div', {
    staticClass: "control no-margin"
  }, [_c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAccount),
      expression: "selectAccount"
    }],
    attrs: {
      "options": _vm.dianjingAccountList
    },
    domProps: {
      "value": (_vm.selectAccount)
    },
    on: {
      "input": function($event) {
        _vm.selectAccount = $event
      }
    }
  })], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("人群名称：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crowdName),
      expression: "crowdName"
    }],
    attrs: {
      "name": "name",
      "placeholder": "请输入人群名称"
    },
    domProps: {
      "value": (_vm.crowdName)
    },
    on: {
      "input": function($event) {
        _vm.crowdName = $event
      }
    }
  })], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("人群计算时间：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v("最近"), _c('span', [_c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectDays),
      expression: "selectDays"
    }],
    attrs: {
      "options": _vm.daysOptions
    },
    domProps: {
      "value": (_vm.selectDays)
    },
    on: {
      "input": function($event) {
        _vm.selectDays = $event
      }
    }
  })], 1), _vm._v("天"), _c('span', {
    staticClass: "custom-day"
  }, [_vm._v("自定义")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("人群规模：")]), _c('div', {
    staticClass: "control"
  }, [_vm._v(_vm._s(_vm.crowdNum))])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "btn-container"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-small btn-mgr",
    on: {
      "click": function($event) {
        _vm.submitSync()
      }
    }
  }, [_vm._v("确认")]), _c('button', {
    staticClass: "btn btn-default btn-small",
    on: {
      "click": _vm.closeSyncSetting
    }
  }, [_vm._v("取消")])])])])]), _c('v-modal', {
    ref: "formCrowdModal",
    attrs: {
      "visible": _vm.crowdVisible,
      "title": _vm.modalTitle
    },
    on: {
      "closemodal": function($event) {
        _vm.closeCrowdModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-bd"
  }, [(_vm.crowdVisible) ? _c('CrowdTemplate', {
    attrs: {
      "crowd": _vm.crowd,
      "type": _vm.crowdType
    },
    on: {
      "validate": _vm.submit,
      "updateItem": _vm.centerModal
    },
    scopedSlots: {
      "btnwraper": function(props) {
        return [_c('div', {
          staticClass: "btn-container"
        }, [_c('button', {
          staticClass: "btn btn-primary btn-small btn-mgr",
          attrs: {
            "type": "button",
            "disabled": _vm.crowdType == 'show'
          },
          on: {
            "click": function($event) {
              _vm.submitModal(props.crowd)
            }
          }
        }, [_vm._v("确认")]), _c('button', {
          staticClass: "btn btn-default btn-small",
          attrs: {
            "type": "button",
            "disabled": _vm.crowdType == 'show'
          },
          on: {
            "click": _vm.closeCrowdModal
          }
        }, [_vm._v("取消")])])]
      }
    }
  }) : _vm._e()], 1)]), _c('v-modal', {
    ref: "mvModal",
    attrs: {
      "visible": _vm.isMv,
      "title": ""
    },
    on: {
      "closemodal": _vm.gotoSetting
    }
  }, [_c('div', {
    staticClass: "modal-bd"
  }, [_c('p', {
    staticClass: "text-content"
  }, [_vm._v("使用该功能需要在网站部署360分析代码")]), _c('p', {
    staticClass: "mv-container"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-small btn-mgr",
    on: {
      "click": function($event) {
        _vm.gotoSetting()
      }
    }
  }, [_vm._v("去设置")])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c52f20fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c52f20fe!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/setting/crowdSegmentation.vue
// module id = 797
// module chunks = 0